<button aria-label="Close" class="close" mat-icon-button>
  <mat-icon (click)="onCloseClick()">close</mat-icon>
</button>
<h1 class="title" mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  {{data.message}}
</div>
